/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_TitleInputs */

const en_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const id_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara kerjanya`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Landing_How_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_how_title = /** @type {((inputs?: Landing_How_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_how_title(inputs)
	return en_landing_how_title(inputs)
});